import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  constructor() {}

  log(message: string): void {
    //
    console.debug('LoggingService:', message);
  }
}